import { Directive } from '@angular/core';

/** Keep neutral, auxiliary and primary actions in DOM order, including on narrow screens. */
@Directive({ selector: '[appActionBar]', standalone: false, host: { class: 'app-action-bar' } })
export class ActionBarDirective {}
